import { render, staticRenderFns } from "./CheckBoxGroup.vue?vue&type=template&id=6df40bd9"
import script from "./CheckBoxGroup.vue?vue&type=script&lang=ts"
export * from "./CheckBoxGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports